import Vue from 'vue'
import Hyperion from './mixin/hyperion'
import qs from 'qs'
import validator from 'validator'
import Clipboard from 'v-clipboard'
import VJsonEditor from 'v-jsoneditor'
import VueJsonPretty from 'vue-json-pretty'

// register base layout component
import BaseLayout from './BaseLayout'

require('./bootstrap')

Vue.use(require('ant-design-vue'))
Vue.use(require('vue-shortkey'), {prevent: ['input', 'textarea']})
Vue.use(Clipboard)
Vue.use(VJsonEditor)

// register proto object
Vue.prototype.$http = window.axios.create()
Vue.prototype.$hyperion = window.Hyperion
Vue.prototype.$qs = qs
Vue.prototype.$validator = validator
Vue.prototype.$echo = window.Echo

Vue.component('base-layout', BaseLayout)
Vue.component('vue-json-pretty', VueJsonPretty)

const files = require.context('./components', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.mixin(Hyperion)

new Vue({
  el: '#app',
  data() {
    return {}
  }
})
